import React from 'react'
import moment from "moment";
import Cookie from "js-cookie";
import { Link, withRouter } from 'react-router-dom'
import { Menu, Icon, Row, Col, } from 'antd'

const { SubMenu } = Menu
class MenuRouter extends React.Component {
    state = {
        openKeys: undefined,
        menus: [],
        showMenu: false,
    }

    componentDidMount () {
        document.title = this.props.title
        const menus = this.filterMenus(this.props.menus ? JSON.parse(JSON.stringify(this.props.menus)) : [])
        let openKeys = menus.findIndex((item, index) => {
            return item.children && item.children.length ? item.children.find(item2 => item2.path === this.props.location.pathname) : item.path === this.props.location.pathname
        })
        this.setState({
            menus: menus,
            openKeys: openKeys.toString(),
        })
        window.addEventListener('showMenu', this.handleShowMenu);
    }

    componentWillUnmount () {
        window.removeEventListener('showMenu', this.handleShowMenu);
    }

    handleShowMenu = () => {
        this.setState({ showMenu: true })
    };

    handleHidenMenu = () => {
        this.setState({ showMenu: false })
    };

    filterMenus = (menus, isOn = false) => {
        return menus.filter(item => {
            const isShow = item.showMenu !== false && (!item.permission || isOn)
            if (isShow && item.children) item.children = this.filterMenus(item.children, isOn)
            return isShow
        })
    }

    renderSubMenu = (menu, index, props) => {
        return (
            <SubMenu
                key={String(index)}
                title={
                    <div>
                        <Icon type={menu.icon} />
                        <span>{menu.title}</span>
                    </div>
                }
            >
                {
                    menu.children.map(menu => (
                        menu.children ? this.renderSubMenu(menu, index, props) : this.renderMenuItem(menu, index, props)
                    ))
                }
            </SubMenu>
        )
    }

    renderMenuItem = (menu, index, props) => {
        return (
            <Menu.Item key={menu.path}>
                {
                    menu.icon && <Icon type={menu.icon} />
                }
                <Link to={menu.path}>{menu.title}</Link>
            </Menu.Item>
        )
    }

    handleOpenChange = (keys) => {
        this.setState({ openKeys: keys[keys.length - 1] })
    }

    render () {
        return (
            <>
                <div className={`menu-mask ${this.state.showMenu ? 'show-menu-mask' : ''}`} onClick={this.handleHidenMenu}></div>
                <div className={`menu-container ${this.state.showMenu ? 'show-menu-container' : ''}`} >
                    <div className="title-box">
                        {(window.location.origin === process.env.REACT_APP_API_UNION_BACKGROUND_ADDRESS || window.location.origin === process.env.REACT_APP_DIRECT_UNION_BACKGROUND_ADDRESS) ?
                            <img className="logo" src='/kpoker_logo.png' width={25} height={25} />
                            :
                            <img className="logo" src='/union_logo.png' width={25} height={25} />
                        }
                        <h2 className='title'>{this.props.title}</h2>
                    </div>
                    <div className="menu-content">
                        <Menu
                            mode="inline"
                            style={{ borderRight: 'none' }}
                            selectedKeys={[this.props.location.pathname]}
                            openKeys={[this.state.openKeys]}
                            onOpenChange={this.handleOpenChange}
                        >
                            {
                                this.state.menus.map((item, index) => (
                                    item.children ? this.renderSubMenu(item, index, this.props) : this.renderMenuItem(item, index, this.props)
                                ))
                            }
                        </Menu>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(MenuRouter)
